import type { HttpGet } from '@/shared/infra/http'
import type { GroupedHuntPhotosResult } from '@/shared/domain'
import type { ListGroupedHuntPhotos } from '@/modules/gallery/use-cases'
import { buildGalleryQueryString } from './build-gallery-query-string'

export class SupabaseListGroupedHuntPhotosRepository {
  constructor(private readonly http: HttpGet) {}

  execute: ListGroupedHuntPhotos = async (params) => {
    return this.http.get<GroupedHuntPhotosResult>({
      url: `/hunt-photos/grouped${buildGalleryQueryString(params)}`,
    })
  }
}
